import { detectClientEnvironment } from "./detectClientEnvironment";
import type { ClientEnvironment } from "./types";

export type ClientPlatformOS = "IOS" | "ANDROID" | "WINDOWS" | "UNKNOWN";

export interface ClientPlatformInfo {
  os: ClientPlatformOS;
  device: number;
  isNative: boolean;
  isMobile: boolean;
}

const resolveOSFromUA = (uaRaw: string): ClientPlatformOS => {
  const ua = uaRaw || "";

  if (/(iphone|ipad|ipod|macintosh|macintel|macppc|mac68k)/i.test(ua)) {
    return "IOS";
  }

  if (/android/i.test(ua)) {
    return "ANDROID";
  }

  if (/(win32|win64|windows|wince)/i.test(ua)) {
    return "WINDOWS";
  }

  return "UNKNOWN";
};

export const getClientPlatformInfo = (
  env: ClientEnvironment = detectClientEnvironment()
): ClientPlatformInfo => {
  const os = resolveOSFromUA(env.ua.ua);
  const isNative = env.isNativeWebView || env.isFlutterWebView;
  const isMobile = env.ua.isMobile;

  let device = 3;

  if (os === "IOS") {
    device = isNative ? 4 : 1;
  } else if (os === "ANDROID") {
    device = isNative ? 5 : 2;
  }

  return {
    os,
    device,
    isNative,
    isMobile,
  };
};

export default getClientPlatformInfo;
